import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { NeedsDiagnosisPage } from './needs-diagnosis';

@NgModule({
  declarations: [
    NeedsDiagnosisPage,
  ],
  imports: [
    IonicPageModule.forChild(NeedsDiagnosisPage),
  ],
})
export class NeedsDiagnosisPageModule {}



// WEBPACK FOOTER //
// ./src/pages/needs-diagnosis/needs-diagnosis.module.ts